import { render, staticRenderFns } from "./MenuColor.vue?vue&type=template&id=cf5c9c0e&"
import script from "./MenuColor.vue?vue&type=script&lang=js&"
export * from "./MenuColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports